import StoredAnalysis from 'domain/entity/storedAnalysis';
import { Result } from 'domain/types';
import { CreateStoredAnalysisClient } from 'use-case/storedAnalysis/create/createStoredAnalysisClient';
import CreateStoredAnalysisCriteria from 'use-case/storedAnalysis/create/createStoredAnalysisCriteria';

export type CreateStoredAnalysisResult = Result<StoredAnalysis>;
export type CreateStoredAnalysis = (criteria: CreateStoredAnalysisCriteria) => Promise<CreateStoredAnalysisResult>;

export const createStoredAnalysisUseCase = (createStoredAnalysisClient: CreateStoredAnalysisClient): CreateStoredAnalysis => (
    criteria: CreateStoredAnalysisCriteria
): Promise<CreateStoredAnalysisResult> => createStoredAnalysisClient(criteria);
